var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.128 10.118c.346 0 .654-.044.91-.143v-.847c-.269.132-.564.198-.91.198-.474 0-.718-.187-.718-.561 0-.297.27-.616.82-.958l.783-.517c.14-.099.32-.242.513-.429.397-.385.474-.737.474-1.276 0-.309-.128-.65-.436-.99C9.256 4.241 8.628 4 7.821 4c-.693 0-1.295.176-1.821.54v.968c.577-.474 1.18-.716 1.82-.716 1.154 0 1.18.738 1.18.826 0 .385-.077.627-.397.902a2.633 2.633 0 0 1-.424.33l-.628.396c-.756.473-1.14.98-1.14 1.519 0 .825.679 1.353 1.717 1.353Zm-.743 1.717c.256.22.64.22.897 0a.482.482 0 0 0 0-.77.693.693 0 0 0-.897 0 .482.482 0 0 0 0 .77Z",
    fill: "currentColor"
  })));
};
export default SvgQuestion;